import { CoveringType } from '../../interfaces/GenericInterfaces';
import { TextureDataDTO } from './TextureDataDTO';

export class CoveringDTO {
  public type: CoveringType;
  public thumbnail: string;
  public textureData: TextureDataDTO;

  constructor(type: CoveringType, textureData: TextureDataDTO, thumbnail?: string) {
    this.type = type;
    this.textureData = textureData;
    this.thumbnail = thumbnail || '';
  }

  clone(): CoveringDTO {
    return new CoveringDTO(this.type, this.textureData.clone(), this.thumbnail);
  }
}
